'use strict';

var buildSimpleValidator = require('./helpers/build-simple-validator');
var _isNil = require('lodash/isNil');

module.exports = buildSimpleValidator(function (value) {
  return !_isNil(value);
}, 'Value is required');